/**
 * ActivityImagesSection – thin wrapper around the canonical MediaImageManager.
 * Used in ActivityComposer for event image management.
 */

import { MediaImageManager, type UploadHook } from '@/components/media/MediaImageManager';
import { useMediaAssets } from '@/hooks/useMediaAssets';


interface ActivityImagesSectionProps {
  coverUpload: UploadHook;
  galleryUpload: UploadHook;
  eventId?: string | null;
  producerId?: string;
  draftSessionId: string;
  disabled?: boolean;
  className?: string;
}

export function ActivityImagesSection({
  coverUpload,
  galleryUpload,
  eventId,
  producerId,
  draftSessionId,
  disabled = false,
  className,
}: ActivityImagesSectionProps) {
  const { data: coverAssets = [] } = useMediaAssets('event', eventId, 'cover');
  const { data: galleryAssets = [] } = useMediaAssets('event', eventId, 'gallery');
  const imageCount = coverAssets.length + galleryAssets.length;

  return (
    <div className={className}>
      {imageCount === 0 && (
        <p className="text-sm text-muted-foreground mb-3">
          Bilder hjälper gäster att förstå känslan. Lägg till 1–3 bilder.
        </p>
      )}
      <MediaImageManager
        ownerType="event"
        ownerId={eventId}
        producerId={producerId}
        draftSessionId={draftSessionId}
        coverUpload={coverUpload}
        galleryUpload={galleryUpload}
        disabled={disabled}
        helperText="Valfritt · Lägg till 1–3 bilder nu, fler senare."
      />
    </div>
  );
}
